import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Token} from "../../../../../server/src/typescript-plugin/entities/Token";
import {ServerError} from "../../../../../server/src/typescript-plugin/error/ServerError";
import {ISerializable} from "../../../../../server/src/typescript-plugin/entities/ISerializable";

export class ApiAccessService {

    private token:Token;

    constructor(private http:HttpClient) {
        this.token = new Token();
    }

    public Get<T extends ISerializable>(url:string,
                                        serializable:{ new():T},
                                        headers:HttpHeaders = new HttpHeaders()):Promise<T> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }

        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.get(finalUrl, { headers:headers, observe: 'response'}).toPromise()
            .then(response => {
                return this.DeserializeData(response, new serializable());
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public Post<T extends ISerializable>(url:string,
                                         serializable:T = null,
                                         headers:HttpHeaders = new HttpHeaders()):Promise<void> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        let serializedObject:any = serializable == null ? null : serializable.Serialize();
        return this.http.post(finalUrl, serializedObject, { headers:headers, observe: 'response'}).toPromise()
            .then((response) => {
                return this.DeserializeEmptyResponse(response);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public PostReturn<T extends ISerializable>(url:string,
                                         serializable:T,
                                         headers:HttpHeaders = new HttpHeaders()):Promise<T> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.post(finalUrl, serializable.Serialize(), { headers:headers, observe: 'response'}).toPromise()
            .then((response) => {
                return this.DeserializeData(response, serializable);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public Patch<T extends ISerializable>(url:string,
                                          serializable:T = null,
                                          headers:HttpHeaders = new HttpHeaders()):Promise<void> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        let serializedObject:any = serializable == null ? null : serializable.Serialize();
        return this.http.patch(finalUrl, serializedObject, { headers:headers, observe: 'response'}).toPromise()
            .then((response) => {
                return this.DeserializeEmptyResponse(response);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public PatchReturn<T extends ISerializable>(url:string,
                                                serializable:T = null,
                                          headers:HttpHeaders = new HttpHeaders()):Promise<T> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        let serializedObject:any = serializable == null ? null : serializable.Serialize();
        return this.http.patch(finalUrl, serializedObject, { headers:headers, observe: 'response'}).toPromise()
            .then((response) => {
                return this.DeserializeData(response, serializable);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public Put<T extends ISerializable>(url:string,
                                        serializable:T,
                                        headers:HttpHeaders = new HttpHeaders()):Promise<void> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.put(finalUrl, serializable.Serialize(), { headers:headers, observe: 'response'}).toPromise()
            .then( (response) => {
                return this.DeserializeEmptyResponse(response);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public PutReturn<T extends ISerializable>(url:string,
                                        serializable:T,
                                        headers:HttpHeaders = new HttpHeaders()):Promise<T> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.put(finalUrl, serializable.Serialize(), { headers:headers, observe: 'response'}).toPromise()
            .then( (response) => {
                return this.DeserializeData(response, serializable);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public Delete<T extends ISerializable>(url:string,
                                           headers:HttpHeaders = new HttpHeaders()):Promise<void> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.delete(finalUrl, { headers:headers, observe: 'response'}).toPromise()
            .then( (response) => {
                return this.DeserializeEmptyResponse(response);
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public DeleteReturn<T extends ISerializable>(url:string,
                                           serializable:{ new():T},
                                           headers:HttpHeaders = null):Promise<T> {
        if(this.token.value != null){
            headers = headers.set("Authorization", this.token.value);
        }
        let finalUrl = (url.includes('employee') ? environment.employeeApiUrl : environment.apiUrl) + url;
        return this.http.delete(finalUrl, { headers:headers, observe: 'response'}).toPromise()
            .then( (response) => {
                return this.DeserializeData(response, new serializable());
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    public Authenticate(password:string):Promise<void>{
        return this.http.post(environment.apiUrl + 'admin/token', {password: password}, { headers:null, observe: 'response'}).toPromise()
            .then((response) => {
                this.token.Deserialize(response.body);
                return Promise.resolve();
            }).catch((errorResponse:HttpErrorResponse) => {
                let serverError:ServerError = new ServerError();
                serverError.Deserialize(errorResponse.error);
                throw serverError;
            });
    }

    private DeserializeEmptyResponse(response): Promise<void>{
        if (response.status == 200) {
            return Promise.resolve();
        } else {
            let serverError:ServerError = new ServerError();
            serverError.Deserialize(response);
            throw serverError;
        }
    }

    private DeserializeData<T extends ISerializable>(response, serializable:T): T{
        if (response.status == 200) {
            serializable.Deserialize(response.body);
            return serializable;
        } else {
            let serverError:ServerError = new ServerError();
            serverError.Deserialize(response);
            throw serverError;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/api/ApiAccessService.ts